import { render, staticRenderFns } from "./CandleSad.vue?vue&type=template&id=c4b113da&scoped=true&"
var script = {}
import style0 from "./CandleSad.vue?vue&type=style&index=0&id=c4b113da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b113da",
  null
  
)

export default component.exports